import React from 'react';
import { useLocalization } from '../context/LocalizationContext';

/**
 * ThankYouConfirmation
 * Displays a localized thank you message after detailed report request,
 * and dynamically renders social/contact links if provided in resource file.
 */
const ThankYouConfirmation = () => {
  const { t } = useLocalization();

  // Social/contact links from translation resource (null if not set)
  const socialLinks = [
    { key: 'website', icon: '🌐', label: t('connectWebsite'), url: t('connectWebsiteUrl') },
    { key: 'linkedin', icon: '🔗', label: t('connectLinkedIn'), url: t('connectLinkedInUrl') },
    { key: 'twitter', icon: '🐦', label: t('connectTwitter'), url: t('connectTwitterUrl') },
    { key: 'whatsapp', icon: '💬', label: t('connectWhatsApp'), url: t('connectWhatsAppUrl') },
  ].filter(link => link.url && typeof link.url === 'string' && link.url.trim() && !link.url.startsWith('connect'));

  return (
    <div className="max-w-lg mx-auto p-8 bg-white rounded-lg shadow-lg text-center mt-10">
      <h2 className="text-3xl font-bold text-green-600 mb-4">{t('connectWithOlyra')}</h2>
      <p className="text-lg text-gray-800 mb-6">{t('detailedConnectMsg')}</p>

      {socialLinks.length > 0 && (
        <div className="mt-8">
          <h3 className="text-md font-semibold text-green-600 mb-3">{t('linksOlyra')}</h3>
          <div className="flex flex-wrap justify-center gap-4">
            {socialLinks.map(link => (
              <a
                key={link.key}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center px-4 py-2 bg-blue-900 hover:bg-gray-900 rounded transition"
              >
                <span className="text-xl mr-2">{link.icon}</span>
                <span>{link.label}</span>
              </a>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ThankYouConfirmation;
